<nav
    *transloco="let t; prefix: 'uiBreadcrumb'"
    aria-label="breadcrumb">
    <ol
        class="flex items-center text-xs gap-y-2"
        [class.flex-wrap]="breadcrumbIsExpanded()"
        #breadcrumbElement>
        @for (entry of entries(); track entry; let isLast = $last; let isFirst = $first; let index = $index) {
            @if (index === 1 && !isLast && hasOverflow()) {
                <!-- toggle Breadcrumb on mobile devices -->
                @if (breadcrumbIsExpanded() === false) {
                    <li class="flex items-center shrink-0">
                        @if (!isFirst) {
                            <big-icon
                                [icon]="arrowIcon"
                                [size]="'w-3'"
                                class="fill-body dark:fill-white mx-1.5" />
                        }
                        <button (click)="expandBreadcrumb()">
                            <span class="sr-only">{{ t('showAll') }}</span>
                            …
                        </button>
                    </li>
                }
            }
            @if (!isFirst && (!hasOverflow() || breadcrumbIsExpanded() || isLast)) {
                <big-icon
                    [icon]="arrowIcon"
                    [size]="'w-3'"
                    class="shrink-0 mx-1.5 fill-body dark:fill-white" />
            }
            <!-- the pb-0.5 is to always make the underline visible. Otherwise it is sometimes hidden by overflow. Even with overflow-x-hidden-->
            <li
                class="pb-0.5"
                [class.shrink-0]="!isLast"
                [class.overflow-hidden]="isLast"
                [class.text-ellipsis]="isLast"
                [ngClass]="{
                    'hidden': hasOverflow() && !isFirst && !isLast && breadcrumbIsExpanded() === false,
                    'text-primary dark:text-white underline hover:text-primary-800 dark:hover:text-primary-300': !isLast,
                }">
                @if (!isLast) {
                    <big-ui-link
                        [href]="entry.uri"
                        [linkClass]="'after:hidden font-sans [&>div]:min-h-0 [&>div]:gap-1'">
                        {{ entry.title }}

                        @if (entry.title === 'meineBIG') {
                            <big-icon
                                [icon]="myBigIcon"
                                [size]="'w-3.5'"
                                class="fill-primary" />
                        }
                    </big-ui-link>
                } @else {
                    <span class="text-nowrap">
                        {{ entry.title }}
                    </span>
                }
            </li>
        }
    </ol>
</nav>
